import { useMutation } from "@tanstack/react-query";
import { resendCollaboratorInvite } from "services/accounts";
import { useRootStore } from "store";

export const useResendCollaboratorInvite = () => {
  const {
    authStore,
    uiStore: { setApiErrorToast, setToast },
  } = useRootStore();

  return useMutation({
    mutationFn: ({
      accountId,
      userId,
    }: {
      accountId: string;
      userId: string;
    }) => resendCollaboratorInvite(authStore, accountId, userId),
    onError: (error) => setApiErrorToast(error, "Unable to resend invite"),
    onSuccess: () => {
      setToast({ text: "Invite resent", type: "success", duration: 3000 });
    },
  });
};
